/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ExternalApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get current user
     */
    public getCurrentUser(__unused?: any): Observable<PagedArray<models.ApiUserExternal>> {
        const path = '/external/users/current';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiUserExternal>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
